import { useEffect, useState } from 'react';

import appService from '../../service/app.service';
import DocRoleModify from './DocRoleModify';
import { ButtonUI, DebouncedInputUI } from '../Interface';
import documentTypeService from '../../service/newDocumentType.service';

const DocRoleInformation = ({ roleState }) => {
  const { roleId } = roleState;
  const [roleDocPermissions, setRoleDocPermissions] = useState([]);
  const [allDocs, setAllDocs] = useState([]);
  const [roleModalShow, setRoleModalShow] = useState(false);
  const [roleHasPermission, setRoleHasPermission] = useState(false);
  const [selectedDoc, setselectedDoc] = useState(null);
  const [refreshPage, setRefreshPage] = useState(false);
  const [filter, setFilter] = useState({
    name: '',
  });

  const fetchData = async () => {
    if (!roleId) {
      return;
    }
    appService
      .getDocPermissions(roleId)
      .then((data) => {
        setRoleDocPermissions(data);
      })
      .finally(() => {});
  };

  const fetchAllDocs = async () => {
    documentTypeService
      .allDocumentTypes()
      .then((data) => {
        setAllDocs(data);
      })
      .finally(() => {});
  };

  useEffect(() => {
    fetchAllDocs();
  }, []);

  useEffect(() => {
    fetchData();
  }, [roleId]);

  useEffect(() => {
    fetchData();
  }, [refreshPage]);

  return (
    <>
      <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6 max-h-[calc(100vh-10rem)] overflow-y-auto custom-scrollbar">
        <div>
          <div className="w-[250px] mb-3">
            <DebouncedInputUI
              label="Keresés"
              debounceMs={800}
              quickFilterSearchValue={filter?.name}
              setQuickFilterSearchValue={(newValue) => {
                setFilter((prevState) => ({
                  ...prevState,
                  name: newValue,
                }));
              }}
            />
          </div>
          <table className="mt-2 min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Menüpont
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Jogosult
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Létrehozhat
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Szerkesztheti
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Másolhat
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Törölhet
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  E-mail küldés
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  SMS küldés
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                ></th>
              </tr>
            </thead>
            <tbody>
              {allDocs
                .filter((doc) => doc.name.toLowerCase().includes(filter.name.toLowerCase()))
                .map((docType, index) => (
                  <tr key={index} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}`}>
                    <td className="px-6 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{docType.name}</td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {roleDocPermissions.find((permission) => {
                        return permission.roleDocPermissions.some(
                          (rolePerm) => rolePerm.roleId === roleId && permission.name === docType.name
                        );
                      })
                        ? 'Jogosult'
                        : 'Nem jogosult'}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {roleDocPermissions.find((permission) =>
                        permission.roleDocPermissions.some(
                          (rolePerm) =>
                            rolePerm.roleId === roleId && permission.name === docType.name && rolePerm.canCreate
                        )
                      )
                        ? 'Jogosult'
                        : 'Nem jogosult'}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {roleDocPermissions.find((permission) =>
                        permission.roleDocPermissions.some(
                          (rolePerm) =>
                            rolePerm.roleId === roleId && permission.name === docType.name && rolePerm.canEdit
                        )
                      )
                        ? 'Jogosult'
                        : 'Nem jogosult'}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {roleDocPermissions.find((permission) =>
                        permission.roleDocPermissions.some(
                          (rolePerm) =>
                            rolePerm.roleId === roleId && permission.name === docType.name && rolePerm.canCopy
                        )
                      )
                        ? 'Jogosult'
                        : 'Nem jogosult'}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {roleDocPermissions.find((permission) =>
                        permission.roleDocPermissions.some(
                          (rolePerm) =>
                            rolePerm.roleId === roleId && permission.name === docType.name && rolePerm.canDelete
                        )
                      )
                        ? 'Jogosult'
                        : 'Nem jogosult'}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {roleDocPermissions.find((permission) =>
                        permission.roleDocPermissions.some(
                          (rolePerm) =>
                            rolePerm.roleId === roleId && permission.name === docType.name && rolePerm.canEmailSend
                        )
                      )
                        ? 'Jogosult'
                        : 'Nem jogosult'}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      {roleDocPermissions.find((permission) =>
                        permission.roleDocPermissions.some(
                          (rolePerm) =>
                            rolePerm.roleId === roleId && permission.name === docType.name && rolePerm.canSmsSend
                        )
                      )
                        ? 'Jogosult'
                        : 'Nem jogosult'}
                    </td>
                    <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-500">
                      <ButtonUI
                        onClick={() => {
                          setRoleModalShow(true);
                          setRoleHasPermission(
                            roleDocPermissions.find((permission) =>
                              permission.roleDocPermissions.some(
                                (rolePerm) => rolePerm.roleId === roleId && permission.name === docType.name
                              )
                            )
                              ? true
                              : false
                          );
                          setselectedDoc(docType.documentTypeId);
                        }}
                        variant="gradient"
                        color="blue-gray"
                        size="sm"
                        disabled={!roleId}
                        text="Szerkesztés"
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      <DocRoleModify
        show={roleModalShow}
        onHide={() => setRoleModalShow(false)}
        hasPermission={roleHasPermission}
        roleId={roleId}
        selectedDoc={selectedDoc}
        roleDocPermissions={roleDocPermissions}
        refreshPage={refreshPage}
        setRefreshPage={setRefreshPage}
        setRoleDocPermissions={setRoleDocPermissions}
      />
    </>
  );
};

export default DocRoleInformation;

